module.exports = __webpack_public_path__ + "img/success1.25371443.png";